import { CovidWageSubsidy } from '@app/modules/reporting/reports/covid-wage-subsidy';
import { Benefit } from '@reporting/reports/benefit';
import { JournalEntry } from '@reporting/reports/journal-entry';
import { PayrollRegister } from '@reporting/reports/payroll-register';
import { Remittance } from '@reporting/reports/remittance';
import { YTD } from '@reporting/reports/ytd';

const Reports = [PayrollRegister, YTD, Remittance, JournalEntry, CovidWageSubsidy, Benefit];

export { Reports, PayrollRegister, YTD, Remittance, JournalEntry, CovidWageSubsidy, Benefit };
